<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="100%"
    top="0px"
    class="oder-wait-dialog"
    append-to-bod
    destroy-on-closes
    :show-close="false"
  >
    <slot name="content">
      <span class="whitespace-pre-line">{{ content }}</span>
    </slot>
  </el-dialog>
</template>
<script>
export default {
  name: 'OrderWaitDialog',
  props: {
    visible: Boolean,
    content: {
      type: String,
      default: () => '',
    },
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      },
    },
  },
}
</script>
<style lang="scss">
@import '@/assets/css/components/order-wait-dialog.scss';
</style>
